<template>
	<div class="z-backForm" :class="{right:align}" v-form="name">
		<div class="main">
			<slot></slot>
			<div class="btns" v-if="btns!=false">
				<div>
					<div class="back-btn blue" :class="{disabled:!now_form.changeFlag}" @click="save">{{ btnText || '保存'}}</div>
					<div class="back-btn" :class="{disabled:!now_form.changeFlag}" @click="cancelEdit">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['name',"align","btns",'btnText'],
		data(){
			return {
				now_form:{},
			}
		},
		mounted(){
			let formName = this.name;
			this.now_form = this.$form.forms[formName];
		},
		methods:{
			save(){
				let res = this.$form.check(this.name);
				if(!res){
					return;
				}
				this.$form.breakFlag = true;
				this.$emit("save");
			},
			cancelEdit(){
				let datalist = this.$form.reBack(this.name);
				this.$emit("cancel",datalist);
			},
		}
	}
</script>

<style lang="less">
	@import "~src/assets/less/backless/var.less";
	.z-backStage{
		.z-backForm{
			margin-top: 24px;
			position: relative;
			overflow: hidden;
			padding-bottom: 30px + @form_margin;
			>.main{
				float:left;
			}

			.back-item{
				.back-title{
					float:none;
				}
				.back-wrap{
					float:none;
					position: absolute;
					left: 100%;
					top: 0;
				}
			}

			.btns{
				position: relative;
				&:after{
					content:"";
					display: block;
					clear: both;
				}
				>div{
					position:absolute;
					min-width:200px;  //尽量大
					left:0;
					margin-top: @form_margin;
				}
				.back-btn{
					float: left;
					&+div{
						margin-left:15px;
					}
				}

			}

			// 小标题
			.small-title{
				font-size:13px;
				font-weight:600;
				line-height:30px;
				margin-bottom: @form_margin;
				&:after{
					content:"";
					position: absolute;
					display: block;
					border-bottom: 1px solid #ddd;
					width:100%;
				}
			}

			// 右对齐情况
			&.right{
				.btns{
					left: 100%;
				}
			}
		}

	}
</style>





// WEBPACK FOOTER //
// backForm.vue?2ebfaed0